import fetcher from 'api/fetcher';
import type { ApiFunction, CreateRequestResponseData, Nullable } from 'types';
import type { CampaignGender } from 'utils/constants/campaign';

import type { SalaryRange } from 'store/models/createCampaign';
import type { TrafficLightStatus } from 'store/models/predictWindow';

interface GetAudienceReachPredictionRequest {
    vacancyProfRoleId: string;
    profRoleIdsSelectedByUser: string[];
    sex: CampaignGender;
    age: {
        minValue: number;
        maxValue: number;
        includeAnonymousAge: boolean;
    };
    areas: {
        include: number[];
        exclude: number[];
    };
    salaryRange: Nullable<SalaryRange>;
}

interface GetAudienceReachPredictionResponse {
    audienceReach: number;
    profRolesReachCategory: TrafficLightStatus;
}

export const getAudienceReachPrediction: ApiFunction<
    CreateRequestResponseData<GetAudienceReachPredictionRequest, GetAudienceReachPredictionResponse>
> = (requestProps) => fetcher.put('/api/v1/campaign/audience_reach_prediction', requestProps);

export const getProfRolesPrediction: ApiFunction<
    CreateRequestResponseData<{ vacancyProfRoleId: string }, string[] | []>
> = (requestProps) =>
    fetcher.get(`/api/v1/campaign/prof_roles_prediction?${new URLSearchParams(requestProps).toString()}`);

export const getVacancyProfRole: ApiFunction<
    CreateRequestResponseData<{ vacancyId: string }, { vacancyProfRoleId: string }>
> = (requestProps) => fetcher.get(`/api/v1/vacancy/prof_role_id?${new URLSearchParams(requestProps).toString()}`);
